import { DialogActions, Button, CircularProgress } from '@mui/material';

export function FeedbackDialogActions({
  submissionResult,
  onClose,
  onSubmit,
  submitting,
  canSubmit,
}) {
  return (
    <DialogActions sx={{ px: 3, py: 2 }}>
      {submissionResult ? (
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ fontWeight: 700, px: 4 }}
        >
          Done
        </Button>
      ) : (
        <>
          <Button
            onClick={onClose}
            disabled={submitting}
            color="inherit"
            sx={{ fontWeight: 600 }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={!canSubmit || submitting}
            startIcon={submitting ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ fontWeight: 700, px: 3 }}
          >
            {submitting ? 'Submitting...' : 'Submit Report'}
          </Button>
        </>
      )}
    </DialogActions>
  );
}
